export default {
  // Labels
'Activate the global connect tool' : 'Activar la herramienta de conexión global',
'Append {type}': 'Añadir {type}',
'Add Lane above': 'Añadir línea arriba',
'Divide into two Lanes': 'Divida en dos carriles',
'Divide into three Lanes': 'Divida en tres carriles',
'Add Lane below': 'Agregar línea debajo',
'Append compensation activity': 'Agregar actividad de compensación',
'Append Intermediate/Boundary Event': 'Agregar evento intermedio / límite',
'Append Gateway': 'Agregar puerta de enlace',
'Change type': 'Cambiar tipo',
'Connect using Association': 'Conectar utilizando la Asociación',
'Connect using Sequence/MessageFlow or Association': 'Conectar utilizando secuencia / flujo de mensajes o asociación',
'Connect using DataInputAssociation': 'Conectar usando la Asociación de Entrada de Datos',
'Remove': 'Remover',
'Activate the hand tool': 'Activar la herramienta de mano',
'Activate the lasso tool': 'Activar la herramienta Lazo',
'Activate the create/remove space tool': 'Activar la herramienta de crear / eliminar espacio',
'Create expanded SubProcess': 'Crear Subproceso',
'Create Intermediate/Boundary Event' : 'Crear evento intermedio / límite',
'Create Pool/Participant': 'Crear grupo / participante',
'Create Start Timer Event': 'Crear evento de temporizador de inicio',
'Create StartEvent': 'Crear evento de inicio',
'Create EndEvent': 'Crear evento final',
'Create Gateway': 'Crear puerta de enlace',
'Create Task': 'Crear proceso',
'Create DataObjectReference': 'Crear referencia de entrada/salida',
'Create DataStoreReference': 'Crear referencia de almacén de datos',
'Create Group': 'Crear grupo',
'General': 'General',
'Documentation': 'Documentación',
'Element Documentation': 'Documentación de elemento',
'Append EndEvent': 'Agregar evento final',
'Append Task': 'Agregar proceso',
'Parallel Multi Instance': 'Instancia múltiple paralela',
'Sequential Multi Instance': 'Instancia múltiple secuencial',
'Loop': 'Lazo',
'Ad-hoc': 'Ad-hoc',
'Create {type}': 'Crear {type}',
'Task': 'Proceso',
'Send Task': 'Enviar proceso',
'Receive Task': 'Recibir proceso',
'User Task': 'Proceso de usuario',
'Manual Task': 'Proceso manual',
'Business Rule Task': 'Proceso de regla de negocio',
'Service Task': 'Proceso de servicio',
'Script Task': 'Proceso de script',
'Call Activity': 'Actividad de llamada',
'Sub Process (collapsed)': 'Subproceso (colapsado)',
'Start Event': 'Evento de inicio',
'Intermediate Throw Event': 'Evento de Lanzamiento Intermedio',
'End Event': 'Fin del evento',
'Message Start Event': 'Evento de inicio de mensaje',
'Timer Start Event': 'Evento de inicio del temporizador',
'Conditional Start Event': 'Evento de inicio condicional',
'Signal Start Event': 'Evento de inicio de señal',
'Error Start Event': 'Error al iniciar el evento',
'Escalation Start Event': 'Evento de inicio de escalamiento',
'Compensation Start Event': 'Evento de Compensación',
'Message Start Event (non-interrupting)': 'Evento de inicio de mensaje (sin interrupción)',
'Timer Start Event (non-interrupting)': 'Evento de inicio del temporizador (sin interrupción)',
'Conditional Start Event (non-interrupting)': 'Evento de inicio condicional (sin interrupción)',
'Signal Start Event (non-interrupting)': 'Evento de inicio de señal (sin interrupción)',
'Escalation Start Event (non-interrupting)': 'Evento de inicio de escalamiento (sin interrupción)',
'Message Intermediate Catch Event': 'Evento de captura intermedia del mensaje',
'Message Intermediate Throw Event': 'Evento de Lanzamiento Intermedio del Mensaje',
'Timer Intermediate Catch Event': 'Evento de captura intermedia del temporizador',
'Escalation Intermediate Throw Event': 'Evento de Lanzamiento Intermedio de Escalada',
'Conditional Intermediate Catch Event': 'Evento de captura intermedia condicional',
'Link Intermediate Catch Event': 'Enlace Evento de captura intermedio',
'Link Intermediate Throw Event': 'Evento de Lanzamiento Intermedio de Enlace',
'Compensation Intermediate Throw Event': 'Compensación Evento de tiro intermedio',
'Signal Intermediate Catch Event': 'Evento de captura intermedia de señal',
'Signal Intermediate Throw Event': 'Evento de lanzamiento intermedio de señal',
'Message End Event': 'Evento final del mensaje',
'Escalation End Event': 'Evento final de escalada',
'Error End Event': 'Evento de fin de error',
'Cancel End Event': 'Cancelar evento final',
'Compensation End Event': 'Evento final de compensación',
'Signal End Event': 'Evento de fin de señal',
'Terminate End Event': 'Finalizar evento final',
'Message Boundary Event': 'Evento de límite de mensaje',
'Message Boundary Event (non-interrupting)': 'Evento de límite de mensaje (sin interrupción)',
'Timer Boundary Event': 'Evento límite de temporizador',
'Timer Boundary Event (non-interrupting)': 'Evento límite de temporizador (sin interrupción)',
'Escalation Boundary Event': 'Evento límite de escalada',
'Escalation Boundary Event (non-interrupting)': 'Evento de límite de escalada (sin interrupción)',
'Conditional Boundary Event': 'Evento de límite condicional',
'Conditional Boundary Event (non-interrupting)': 'Evento de límite condicional (sin interrupción)',
'Error Boundary Event': 'Evento de límite de error',
'Cancel Boundary Event': 'Cancelar evento de límite',
'Signal Boundary Event': 'Evento de límite de señal',
'Signal Boundary Event (non-interrupting)': 'Evento de límite de señal (sin interrupción)',
'Compensation Boundary Event': 'Evento Límite de Compensación',
'Exclusive Gateway': 'Puerta de enlace exclusiva',
'Parallel Gateway': 'Puerta de enlace paralela',
'Inclusive Gateway': 'Puerta de enlace inclusiva',
'Complex Gateway': 'Puerta de enlace compleja',
'Event based Gateway': 'Puerta de enlace basada en eventos',
'Transaction': 'Transacción',
'Sub Process': 'Subproceso',
'Event Sub Process': 'Evento Subproceso',
'Collapsed Pool': 'Grupo derrumbado',
'Expanded Pool': 'Grupo ampliado',

// Errors
'no parent for {element} in {parent}': 'no padre para {element} en {parent}',
'no shape type specified': 'ningún tipo de forma especificada',
'flow elements must be children of pools/participants': 'los elementos de flujo deben ser hijos de las piscinas / participantes',
'out of bounds release': 'lanzamiento fuera de límites',
'more than {count} child lanes': 'más de {count} carriles secundarios',
'element required': 'elemento requerido',
'diagram not part of bpmn:Definitions': 'diagrama que no forma parte de bpmn:Definitions',
'no diagram to display': 'no hay diagrama para mostrar',
'no process or collaboration to display': 'ningún proceso o colaboración para mostrar',
'element {element} referenced by {referenced}#{property} not yet drawn': 'elemento {element} referenciado por {referenced}#{property} aún no dibujado',
'already rendered {element}': 'ya procesado {element}',
'failed to import {element}': 'no se pudo importar {element}'
};
